import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { DeleteDialogService } from 'services/delete-dialog-service';
import { ErrorService } from 'services/error-service';
import { InternalDepartmentService } from 'services/internal-department-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class InternalDepartmentDetail {
  private internalDepartment: Models.InternalDepartment;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private internalDepartmentService: InternalDepartmentService,
    private deleteDialogService: DeleteDialogService
  ) {}

  private activate(params) {
    this.internalDepartmentService
      .get(params.Id)
      .then((res) => {
        this.internalDepartment = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updateInternalDepartment() {
    if (this.internalDepartment.LeaderId == '') {
      this.internalDepartment.LeaderId = null;
    }
    this.internalDepartmentService
      .put(this.internalDepartment, this.internalDepartment.Id)
      .then((res) => {
        this.eventAggregator.publish('internalDepartmentListReset', 1);
        this.toastService.showSuccess('internalDepartment.updated');
        this.router.navigateToRoute('internal-department-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private deleteInternalDepartment() {
    this.deleteDialogService.confirmBeforeDelete(
      () => {
        this.internalDepartmentService
          .delete(this.internalDepartment.Id)
          .then((res) => {
            this.eventAggregator.publish('internalDepartmentListReset', 1);
            this.toastService.showSuccess('internalDepartment.deleted');
            this.router.navigateToRoute('internal-department-list');
          })
          .catch((err) => this.errorService.handleError(err));
        }
      );
  }

  private gotoParentView() {
    this.eventAggregator.publish('internalDepartmentListReset', 1);
    this.router.navigateToRoute('internal-department-list');
  }
}
